import { memo } from "react";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import { ApiRoutes } from "consts/enpoints/api";
import { MaxFileSizeBytes } from "consts/merchants";
import useActions from "features/general/useActions";
import { NotificationSeverity } from "features/general/types";
import {
    downloadTemplateEmailsWhitelist,
    downloadTemplateEmailsWhitelistWithoutSdd
} from "features/merchants/api";
import FileUploader, { type FileUploaderProps } from "ui/widgets/FileUploader";
import ImportWhitelistTemplate from "./ImportWhitelistTemplate";

type Props = Pick<
    FileUploaderProps,
    | 'TriggerComponent'
    | 'TriggerComponentProps'
>;

const ImportWhitelist = (props: Props) => {
    const { showNotication } = useActions();

    const onSuccess = () =>
        showNotication({
            message: 'Whitelist uploaded successfully. It will be processed at the next scheduled time.',
            severity: NotificationSeverity.Success
        });

    const supportedFormatsMessage = (
        <Typography
            sx={{
                fontFamily: 'var(--primary-font)',
                fontSize: 12,
                color: 'grey.500',
                fontWeight: 600,
                textDecoration: 'underline'
            }}
            gutterBottom
        >
            Supported formats: .csv, UTF-8 encoded, comma-separated
        </Typography>
    );

    return (
        <FileUploader
            url={ApiRoutes.PostEmailsWhitelist()}
            onSuccess={onSuccess}
            ModalProps={{
                disableCloseOnBackdropClick: true,
                titleSlot: 'Upload Whitelist(s) CSV'
            }}
            FileDropAreaProps={{
                children: supportedFormatsMessage,
                maxSize: MaxFileSizeBytes.WhiteList
            }}
            {...props}
            TriggerComponentProps={{
                children: (
                    <>
                        Import Whitelist (CSV)
                    </>
                ),
                ...props.TriggerComponentProps
            }}
        >
            <Box
                sx={{
                    ml: 1,
                    mb: 2
                }}
            >
                {supportedFormatsMessage}
                <Stack
                    direction='row'
                    spacing={2}
                >
                    <ImportWhitelistTemplate
                        downloadTemplate={downloadTemplateEmailsWhitelist}
                    >
                        Download Template
                    </ImportWhitelistTemplate>
                    <ImportWhitelistTemplate
                        downloadTemplate={downloadTemplateEmailsWhitelistWithoutSdd}
                    >
                        Download Template (Without SDD)
                    </ImportWhitelistTemplate>
                </Stack>
            </Box>
        </FileUploader>
    );
};

export default memo(ImportWhitelist);